/**
 * Guarded against a non-string: a bare `string.charAt(0)` throws on null/undefined, and these
 * helpers run inside reducers (see parseRevisitData), where a throw takes down the whole dispatch
 * and leaves the store on its previous value. That is what froze the Revisits table -- a row with
 * no name arrived, the reducer threw, and every later response was lost the same way, so the table
 * kept showing the ordering it had before the sort.
 */
export const capitalizeFirstLetter = (string) => {
  if (typeof string !== 'string' || !string) return string ?? '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
